<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <h5 class="info-text">Wann soll das Verfahren...</h5>
    </div>
    <div class="md-layout-item md-size-70 md-small-size-100">
      <ul>
        <li>Zeitraum der Veröffentlichung des Los-Verfahrens</li>
        <li>Gewünschter Zeitraum der Umsetzung der Maßnahme</li>
      </ul>
    </div>
    <div class="md-layout-item md-small-size-100">
      <md-field>
        <label for="select"
          >Gewünschter Zeitraum der Umsetzung der Maßnahme</label
        >
        <md-select v-model="select" name="select">
          <md-option value="winter1920">Winter 2019/20</md-option>
          <md-option value="winter2021">Winter 2020/21</md-option>
          <md-option value="sommer19">Sommer 2019</md-option>
          <md-option value="sommer20">Sommer 2020</md-option>
        </md-select>
      </md-field>
    </div>
  </div>
</template>
<script>
// import { SlideYDownTransition } from "vue2-transitions";
export default {
  components: {
    // SlideYDownTransition
  }
};
</script>
<style></style>
